import DoubleRoom from './DoubleRoom'

export default DoubleRoom



// WEBPACK FOOTER //
// ./src/features/Hotel/components/DoubleRoom/index.js